// Provides two way conversions between external formats and Filter Query Format

import { fromObjectSegV2, toObjectSegV2 } from './objectSeg/FilterObjectSegV2';
import { fromCRMSearch, toCRMSearch } from './crmSearch/FilterCRMSearch';
export function DSFilterFromObjectSeg(value, baseFilterFamily, getField, isUngated, serializerOptions) {
  return fromObjectSegV2(value, baseFilterFamily, getField, isUngated, serializerOptions);
}
export function DSFilterToObjectSeg(value, isUngated, serializerOptions) {
  return toObjectSegV2(value, isUngated, serializerOptions);
}
export function DSFilterFromCRMSearch(value, baseFilterFamily, getField, isUngated, serializerOptions) {
  return fromCRMSearch(getField, value, isUngated, baseFilterFamily, serializerOptions);
}
export function DSFilterToCRMSearch(value, isUngated) {
  return toCRMSearch(value, isUngated);
}